import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color", "strokeWidth"];
var __jsx = React.createElement;
import React from "react";
const ChevronUpIcon = _ref => {
  let {
      size = "16",
      color = "currentColor",
      strokeWidth
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5873 13.7496C17.5873 13.9256 17.5199 14.1016 17.3858 14.2356C17.117 14.5045 16.6825 14.5045 16.4137 14.2356L11.1963 9.01821L5.98572 14.2288C5.71759 14.4976 5.28241 14.4976 5.01359 14.2288C4.74547 13.9606 4.74547 13.5255 5.01359 13.2566L11.1963 7.07396L17.3858 13.2635C17.5199 13.3976 17.5873 13.5736 17.5873 13.7496Z",
    fill: color,
    strokeWidth: strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 0
  }));
};
export default ChevronUpIcon;